(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/date-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/date-picker.js');

'use strict';

const formateTime = svs.utils.date.FormatTime;
const _svs$numbergames$camp = svs.numbergames.campaign,
  CAMPAIGN_CONSTANTS = _svs$numbergames$camp.CONSTANTS,
  campaignApi = _svs$numbergames$camp.campaignApi,
  asyncCampaignApi = _svs$numbergames$camp.asyncCampaignApi;
svs.numbergames.results.views.DatePicker = Marionette.View.extend({
  className: 'f-capitalized grid-row gutter-xs-2 gutter-am-0',
  modelEvents: {
    'change:availableDates': 'datePickerSetDisabled',
    'results:change:draw': 'datePickerSetSelected'
  },
  template(data) {
    return svs.components.calendar.partials.calendar(data);
  },
  templateContext() {
    const product = svs.numbergames.productMapping.getProductName(this.model.get('productId'));
    return {
      branding: "calendar-".concat(product.toLowerCase())
    };
  },
  async onRender() {
    const self = this;
    const dateLinkIndexUrl = "".concat(svs.core.data.baseUrl, "/resultat/");
    this.calendar = new svs.components.Calendar({
      el: this.$el,
      isDropDown: true,
      dotted: true,
      datePickerOptions: {
        dateLinkIndexUrl,
        disable: [true],
        onStart() {
          this.component.nodes = svs.numbergames.results.parsers.datePicker.nodesFunc.bind(this.component);
          self.datePickerStart(this);
        },
        onSet(changed) {
          self.datePickerSet(this, changed);
        }
      }
    });
    this.calendarUpdateTitle(this.model.get('selectedDate'));
    await this.updateCampaignData();
    this.calendar.on('render', this.updateCampaignData, this);
  },
  calendarUpdateTitle(date) {
    this.calendar.updateTitle(formateTime('EEEE, d/M (\'v\'w)', date));
  },
  datePickerStart(datePicker) {
    const max = svs.numbergames.results.parsers.datePicker.createDate(svs.numbergames.data.results.todayDateString);
    const select = this.model.get('selectedDate');
    const disable = this.model.get('availableDates');
    datePicker.set({
      max,
      select,
      disable
    }, {
      muted: true
    });
    this.datePicker = datePicker;
  },
  datePickerSet(datePicker, _ref) {
    let select = _ref.select,
      highlight = _ref.highlight;
    if (select) {
      this.model.set('selectedDate', svs.numbergames.results.parsers.datePicker.createDate(select));
      Backbone.history.navigate("/resultat/".concat(formateTime('yyyy-MM-dd', select)));
    }
    if (highlight) {
      const _datePicker$component = datePicker.component.item.view,
        month = _datePicker$component.month,
        year = _datePicker$component.year;
      this.model.trigger('datepicker:month:change', month, year);
    }
  },
  datePickerSetDisabled(model, availableDates) {
    this.datePicker.set({
      disable: availableDates
    });
  },
  datePickerSetSelected() {
    const selectedDate = this.model.get('selectedDate');
    this.calendarUpdateTitle(selectedDate);
    this.datePicker.set({
      select: selectedDate
    }, {
      muted: true
    });
  },
  async updateCampaignData() {
    const productId = this.model.get('productId');
    const _this$calendar$getDat = this.calendar.getDatePicker().component.item.view,
      year = _this$calendar$getDat.year,
      monthIndex = _this$calendar$getDat.month;
    const drawTypeId = CAMPAIGN_CONSTANTS.DRAW_TYPE.CAMPAIGN;
    const campaign = await asyncCampaignApi.getCampaign(productId, {
      year,
      month: monthIndex + 1,
      drawTypeId
    });
    if (!campaign) {
      return;
    }
    const $days = this.el.querySelectorAll('.picker__day--infocus');
    const hasCampaign = day => campaignApi.hasCampaign(productId, {
      date: new Date(year, monthIndex, day),
      drawTypeId
    });
    let prevHadCampaign = false;
    $days.forEach(($day, index) => {
      if (hasCampaign($day.innerHTML)) {
        if (!prevHadCampaign) {
          $day.parentElement.classList.add('picker__day--campaign--first');
        }
        $day.parentElement.classList.add('picker__day--campaign');
        prevHadCampaign = true;
      } else {
        if (prevHadCampaign) {
          $days[index - 1].parentElement.classList.add('picker__day--campaign--last');
        }
        prevHadCampaign = false;
      }
    });
  },
  onDestroy() {
    this.calendar.off('render', this.updateCampaignData, this);
  }
});

 })(window);